import React, { useState } from "react";
import HeaderFour from "../common/header/HeaderFour";
import FooterOne from "../common/footer/FooterOne";
import { Country } from "country-state-city";
import axios from "axios";
import API_URL from "../common/config";
import {
  SuccessNotification,
  ErrorNotification,
} from "../tosterNotification/tosters";
import { useNavigate } from "react-router-dom";
import ElegantPopup1 from "../common/Popup";

const FeedbackForm = () => {
  const features = [
    "Personalized Roadmap",
    "Mentor Matching",
    "Skill Recommendations",
    "Video Analysis",
    "Resume Builder",
    "Other",
  ];
  const countries = Country.getAllCountries();
  const [showPopup, setShowPopup] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    country: "",
    userType: "",
    helpfulnessRating: 3,
    mostUsefulFeature: "",
    otherFeature: "",
    improvements: "",
    wouldRecommend: "",
    interestedInSubscription: "",
    email: "",
    additionalFeedback: "",
  });

  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 4;

  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Clear error for this field
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null,
      });
    }
  };

  const handleClose = async () => {
    setShowPopup(false);
    window.location.reload();
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Clear error for this field
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null,
      });
    }
  };

  const handleFeatureChange = (e) => {
    const { value } = e.target;
    setFormData({
      ...formData,
      mostUsefulFeature: value,
    });

    // Clear error
    if (errors.mostUsefulFeature) {
      setErrors({
        ...errors,
        mostUsefulFeature: null,
      });
    }
  };

  const nextStep = () => {
    const validationErrors = validateStep(currentStep);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);

      // Scroll to the first error
      const firstErrorField = Object.keys(validationErrors)[0];
      const errorElement = document.getElementById(firstErrorField);
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
        errorElement.focus();
      }

      return;
    }

    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
      window.scrollTo(0, 0);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      window.scrollTo(0, 0);
    }
  };
  const validateStep = (step) => {
    const stepErrors = {};

    switch (step) {
      case 1:
        // Personal Information validation
        if (!formData.name.trim()) {
          stepErrors.name = "Name is required";
        } else if (formData.name.trim().length < 2) {
          stepErrors.name = "Name must be at least 2 characters";
        } else if (formData.name.trim().length > 100) {
          stepErrors.name = "Name must be less than 100 characters";
        }

        if (!formData.country) {
          stepErrors.country = "Please select a country";
        }

        if (!formData.userType) {
          stepErrors.userType = "Please select an option";
        }
        break;

      case 2:
        // Feature feedback validation
        if (!formData.mostUsefulFeature) {
          stepErrors.mostUsefulFeature = "Please select a feature";
        } else if (
          formData.mostUsefulFeature === "Other" &&
          !formData.otherFeature.trim()
        ) {
          stepErrors.otherFeature = "Please specify the other feature";
        }
        break;

      case 3:
        // Recommendations validation
        if (!formData.wouldRecommend) {
          stepErrors.wouldRecommend = "Please select an option";
        }

        if (!formData.interestedInSubscription) {
          stepErrors.interestedInSubscription = "Please select an option";
        }
        break;

      case 4:
        // Email validation (optional field)
        if (formData.email.trim() !== "") {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(formData.email)) {
            stepErrors.email = "Please enter a valid email address";
          }
        }
        break;

      default:
        break;
    }

    return stepErrors;
  };

  const validate = () => {
    const newErrors = {};

    // Name validation
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    } else if (formData.name.trim().length < 2) {
      newErrors.name = "Name must be at least 2 characters";
    } else if (formData.name.trim().length > 100) {
      newErrors.name = "Name must be less than 100 characters";
    }

    // Country validation
    if (!formData.country) {
      newErrors.country = "Please select a country";
    }

    // User type validation
    if (!formData.userType) {
      newErrors.userType = "Please select an option";
    }

    // Feature validation
    if (!formData.mostUsefulFeature) {
      newErrors.mostUsefulFeature = "Please select a feature";
    } else if (
      formData.mostUsefulFeature === "Other" &&
      !formData.otherFeature.trim()
    ) {
      newErrors.otherFeature = "Please specify the other feature";
    }

    // Recommendation validation
    if (!formData.wouldRecommend) {
      newErrors.wouldRecommend = "Please select an option";
    }

    // Subscription validation
    if (!formData.interestedInSubscription) {
      newErrors.interestedInSubscription = "Please select an option";
    }

    // Email validation (optional field)
    if (formData.email.trim() !== "") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        newErrors.email = "Please enter a valid email address";
      }
    }

    return newErrors;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formErrors = validate();

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);

      // Scroll to the first error
      const firstErrorField = Object.keys(formErrors)[0];
      const errorElement = document.getElementById(firstErrorField);
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
        errorElement.focus();
      }

      return;
    }

    try {
      const response = await axios.post(
        `${API_URL}/api/feedback/`,
        {
          formData,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        SuccessNotification(response.data?.message || "Feedback saved!");
        setSubmitted(true);
        // navigate("/thank-you", {
        //   state: {
        //     message:
        //       "Thank you for taking the time to share your feedback about CLIF AI! Your insights are valuable as we continue to improve and develop our platform to better serve your career journey needs. We greatly appreciate your participation in helping us shape the future of CLIF AI.",
        //   },
        // });
        setShowPopup(true);
      } else {
        ErrorNotification(response.data.message || "Something went wrong");
      }
    } catch (error) {
      ErrorNotification("An error occurred while submitting your feedback");
      console.error("Form submission error:", error);
    }
  }; // Custom styles with the specified color scheme
  const styles = {
    mainBackground: {
      backgroundColor: "#FFFFFF",
    },
    primaryButton: {
      backgroundColor: "#6600CC",
      borderColor: "#6600CC",
      color: "white",
      transition: "all 0.3s ease",
    },
    primaryButtonHover: {
      backgroundColor: "#006600",
      borderColor: "#006600",
      transform: "translateY(-2px)",
      boxShadow: "0 4px 8px rgba(0, 102, 0, 0.3)",
    },
    formElement: {
      borderRadius: "8px",
      transition: "all 0.3s ease",
      border: "1px solid #E0E0E0",
    },
    formCheck: {
      cursor: "pointer",
      padding: "12px 15px",
      borderRadius: "8px",
      transition: "all 0.3s ease",
      marginBottom: "12px",
    },
    formCheckHover: {
      backgroundColor: "rgba(0, 102, 0, 0.05)",
    },
    ratingButton: {
      borderColor: "#6600CC",
      color: "#6600CC",
      margin: "0 3px",
      width: "45px",
      height: "45px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.3s ease",
      borderRadius: "8px",
      fontWeight: "500",
    },
    ratingButtonActive: {
      backgroundColor: "#6600CC",
      borderColor: "#6600CC",
      color: "white",
    },
    formControlFocus: {
      borderColor: "#006600",
      boxShadow: "0 0 0 0.2rem rgba(0, 102, 0, 0.25)",
    },
    cardShadow: {
      boxShadow: "0 15px 35px rgba(102, 0, 204, 0.1)",
      borderRadius: "16px",
      border: "none",
      overflow: "hidden",
    },
    headerGradient: {
      background: "linear-gradient(135deg, #6600CC, #9933FF)",
      padding: "40px 30px",
      borderRadius: "16px 16px 0 0",
      color: "white",
      textAlign: "center",
    },
    progressBar: {
      height: "8px",
      backgroundColor: "#E0E0E0",
      borderRadius: "4px",
      margin: "20px 0",
      position: "relative",
    },
    progressIndicator: {
      height: "100%",
      backgroundColor: "#6600CC",
      borderRadius: "4px",
      transition: "width 0.5s ease",
    },
    stepCircle: {
      width: "36px",
      height: "36px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "white",
      fontWeight: "600",
      fontSize: "14px",
      margin: "0 auto 10px",
      transition: "all 0.3s ease",
    },
    stepCircleActive: {
      backgroundColor: "#6600CC",
      boxShadow: "0 4px 10px rgba(102, 0, 204, 0.3)",
    },
    stepCircleCompleted: {
      backgroundColor: "#006600",
      boxShadow: "0 4px 10px rgba(0, 102, 0, 0.3)",
    },
    stepCirclePending: {
      backgroundColor: "#E0E0E0",
      color: "#666666",
    },
    stepText: {
      fontSize: "13px",
      fontWeight: "500",
      textAlign: "center",
      marginBottom: "5px",
      transition: "all 0.3s ease",
    },
    stepTextActive: {
      color: "#6600CC",
    },
    stepTextCompleted: {
      color: "#006600",
    },
    stepTextPending: {
      color: "#888888",
    },
    resetButton: {
      backgroundColor: "#f8f9fa",
      borderColor: "#d3d3d3",
      color: "#666666",
      transition: "all 0.3s ease",
      borderRadius: "8px",
      padding: "12px 24px",
    },
    resetButtonHover: {
      backgroundColor: "#e9ecef",
      color: "#333333",
    },
    submitButton: {
      backgroundColor: "#6600CC",
      color: "#fff",
      borderRadius: "8px",
      padding: "12px 28px",
      fontSize: "16px",
      fontWeight: "500",
      border: "none",
      transition: "all 0.3s ease",
      boxShadow: "0 4px 12px rgba(102, 0, 204, 0.3)",
    },
    submitButtonHover: {
      backgroundColor: "#006600",
      boxShadow: "0 6px 15px rgba(0, 102, 0, 0.4)",
      transform: "translateY(-2px)",
    },
    stepButton: {
      padding: "12px 24px",
      borderRadius: "8px",
      fontWeight: "500",
      fontSize: "15px",
      transition: "all 0.3s ease",
    },
    inputLabel: {
      fontWeight: "600",
      marginBottom: "8px",
      fontSize: "16px",
      color: "#333333",
    },
    requiredStar: {
      color: "#E53935",
      marginLeft: "3px",
    },

    inputField: {
      padding: "5px 16px",
      fontSize: "15px",
      border: "1px solid #E0E0E0",
      boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    },
    formSection: {
      padding: "30px",
    },
  }; // Form steps content
  const renderStepContent = (step) => {
    switch (step) {
      case 1:
        return (
          <>
            <h2 className="mb-4 text-center">Personal Information</h2>

            {/* Name Field */}
            <div className="mb-4">
              <label
                htmlFor="name"
                className="form-label"
                style={styles.inputLabel}
              >
                Your Name
                <span style={styles.requiredStar}>*</span>
              </label>
              <input
                type="text"
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Enter your name"
                style={{
                  ...styles.formElement,
                  ...styles.inputField,
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#006600";
                  e.target.style.boxShadow =
                    "0 0 0 0.2rem rgba(0, 102, 0, 0.25)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "";
                  e.target.style.boxShadow = "";
                }}
              />
              {errors.name && (
                <div className="invalid-feedback">{errors.name}</div>
              )}
            </div>

            {/* Country Dropdown */}
            <div className="mb-4">
              <label
                htmlFor="country"
                className="form-label"
                style={styles.inputLabel}
              >
                Country
                <span style={styles.requiredStar}>*</span>
              </label>
              <select
                className={`form-select ${errors.country ? "is-invalid" : ""}`}
                id="country"
                name="country"
                value={formData.country}
                onChange={handleInputChange}
                style={{
                  ...styles.formElement,
                  ...styles.inputField,
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#006600";
                  e.target.style.boxShadow =
                    "0 0 0 0.2rem rgba(0, 102, 0, 0.25)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "";
                  e.target.style.boxShadow = "";
                }}
              >
                <option value="" hidden>
                  Select a country
                </option>
                {countries.map((country) => (
                  <option key={country.isoCode} value={country.isoCode}>
                    {country.name}
                  </option>
                ))}
              </select>
              {errors.country && (
                <div className="invalid-feedback">{errors.country}</div>
              )}
            </div>

            {/* User Type */}
            <div className="mb-4">
              <label className="form-label" style={styles.inputLabel}>
                You are a<span style={styles.requiredStar}>*</span>
              </label>
              <div className="mb-2 mt-3">
                {[
                  {
                    value: "university",
                    label: "🎓 University Representative",
                  },
                  {
                    value: "organization",
                    label: "🏢 Organization Representative",
                  },
                  {
                    value: "recruiter",
                    label: "🧑‍💼 Recruiter",
                  },
                  {
                    value: "individual",
                    label: "🙋 Individual (Student/Professional)",
                  },
                ].map((option) => (
                  <div
                    key={option.value}
                    className="form-check mb-3"
                    style={{
                      ...styles.formCheck,
                      backgroundColor:
                        formData.userType === option.value
                          ? "rgba(102, 0, 204, 0.1)"
                          : "transparent",
                      border:
                        formData.userType === option.value
                          ? "1px solid #6600CC"
                          : "1px solid #e0e0e0",
                    }}
                    onMouseOver={(e) => {
                      if (formData.userType !== option.value) {
                        e.currentTarget.style.backgroundColor =
                          "rgba(0, 102, 0, 0.05)";
                        e.currentTarget.style.borderColor = "#006600";
                      }
                    }}
                    onMouseOut={(e) => {
                      if (formData.userType !== option.value) {
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.borderColor = "#e0e0e0";
                      }
                    }}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="userType"
                      id={option.value}
                      value={option.value}
                      checked={formData.userType === option.value}
                      onChange={handleRadioChange}
                    />
                    <label
                      className="form-check-label w-100"
                      htmlFor={option.value}
                      style={{ cursor: "pointer", fontWeight: "500" }}
                    >
                      {option.label}
                    </label>
                  </div>
                ))}
              </div>
              {errors.userType && (
                <div className="text-danger small">{errors.userType}</div>
              )}
            </div>
          </>
        );
      case 2:
        return (
          <>
            <h2 className="mb-4 text-center">Your Experience</h2>

            {/* Helpfulness Rating */}
            <div className="mb-4">
              <label className="form-label" style={styles.inputLabel}>
                On a scale of 1-5, how helpful did you find CLIF AI for your
                career journey?
              </label>
              <div className="d-flex align-items-center justify-content-center mt-4 mb-4">
                <span className="me-4 text-muted">Not helpful</span>
                <div className="d-flex" role="group">
                  {[1, 2, 3, 4, 5].map((rating) => (
                    <React.Fragment key={rating}>
                      <input
                        type="radio"
                        className="btn-check"
                        name="helpfulnessRating"
                        id={`rating-${rating}`}
                        value={rating}
                        checked={
                          parseInt(formData.helpfulnessRating) === rating
                        }
                        onChange={handleRadioChange}
                        autoComplete="off"
                      />
                      <label
                        className="btn"
                        htmlFor={`rating-${rating}`}
                        style={{
                          ...styles.ratingButton,
                          backgroundColor:
                            parseInt(formData.helpfulnessRating) === rating
                              ? "#6600CC"
                              : "transparent",
                          color:
                            parseInt(formData.helpfulnessRating) === rating
                              ? "white"
                              : "#6600CC",
                        }}
                        onMouseOver={(e) => {
                          if (parseInt(formData.helpfulnessRating) !== rating) {
                            e.currentTarget.style.backgroundColor =
                              "rgba(0, 102, 0, 0.1)";
                            e.currentTarget.style.borderColor = "#006600";
                          }
                        }}
                        onMouseOut={(e) => {
                          if (parseInt(formData.helpfulnessRating) !== rating) {
                            e.currentTarget.style.backgroundColor =
                              "transparent";
                            e.currentTarget.style.borderColor = "#6600CC";
                          }
                        }}
                      >
                        {rating}
                      </label>
                    </React.Fragment>
                  ))}
                </div>
                <span className="ms-4 text-muted">Extremely helpful</span>
              </div>
            </div>

            {/* Most Useful Feature */}
            <div className="mb-4">
              <label
                htmlFor="mostUsefulFeature"
                className="form-label"
                style={styles.inputLabel}
              >
                What feature did you find most useful?
                <span style={styles.requiredStar}>*</span>
              </label>
              <select
                className={`form-select ${
                  errors.mostUsefulFeature ? "is-invalid" : ""
                }`}
                id="mostUsefulFeature"
                name="mostUsefulFeature"
                value={formData.mostUsefulFeature}
                onChange={handleFeatureChange}
                style={{
                  ...styles.formElement,
                  ...styles.inputField,
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#006600";
                  e.target.style.boxShadow =
                    "0 0 0 0.2rem rgba(0, 102, 0, 0.25)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "";
                  e.target.style.boxShadow = "";
                }}
              >
                <option value="" hidden>
                  Select a feature
                </option>
                {features.map((feature, index) => (
                  <option key={index} value={feature}>
                    {feature}
                  </option>
                ))}
              </select>
              {errors.mostUsefulFeature && (
                <div className="invalid-feedback">
                  {errors.mostUsefulFeature}
                </div>
              )}

              {formData.mostUsefulFeature === "Other" && (
                <div className="mt-3">
                  <input
                    type="text"
                    className={`form-control ${
                      errors.otherFeature ? "is-invalid" : ""
                    }`}
                    name="otherFeature"
                    value={formData.otherFeature}
                    onChange={handleInputChange}
                    placeholder="Please specify which feature"
                    style={{
                      ...styles.formElement,
                      ...styles.inputField,
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#006600";
                      e.target.style.boxShadow =
                        "0 0 0 0.2rem rgba(0, 102, 0, 0.25)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "";
                      e.target.style.boxShadow = "";
                    }}
                  />
                  {errors.otherFeature && (
                    <div className="invalid-feedback">
                      {errors.otherFeature}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Improvements */}
            <div className="mb-4">
              <label
                htmlFor="improvements"
                className="form-label"
                style={styles.inputLabel}
              >
                What would you like to see improved or added?
              </label>
              <textarea
                className="form-control"
                id="improvements"
                name="improvements"
                rows="4"
                value={formData.improvements}
                onChange={handleInputChange}
                placeholder="Your suggestions for improvement"
                style={{
                  ...styles.formElement,
                  ...styles.inputField,
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#006600";
                  e.target.style.boxShadow =
                    "0 0 0 0.2rem rgba(0, 102, 0, 0.25)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "";
                  e.target.style.boxShadow = "";
                }}
              ></textarea>
            </div>
          </>
        );
      case 3:
        return (
          <>
            <h2 className="mb-4 text-center">Recommendations</h2>

            {/* Would Recommend */}
            <div className="mb-4">
              <label className="form-label" style={styles.inputLabel}>
                Would you recommend CLIF AI to others?
                <span style={styles.requiredStar}>*</span>
              </label>
              <div className="mb-2 mt-3">
                {[
                  { value: "yes", label: "Yes" },
                  { value: "no", label: "No" },
                  { value: "maybe", label: "Maybe" },
                ].map((option) => (
                  <div
                    key={option.value}
                    className="form-check mb-3"
                    style={{
                      ...styles.formCheck,
                      backgroundColor:
                        formData.wouldRecommend === option.value
                          ? "rgba(102, 0, 204, 0.1)"
                          : "transparent",
                      border:
                        formData.wouldRecommend === option.value
                          ? "1px solid #6600CC"
                          : "1px solid #e0e0e0",
                    }}
                    onMouseOver={(e) => {
                      if (formData.wouldRecommend !== option.value) {
                        e.currentTarget.style.backgroundColor =
                          "rgba(0, 102, 0, 0.05)";
                        e.currentTarget.style.borderColor = "#006600";
                      }
                    }}
                    onMouseOut={(e) => {
                      if (formData.wouldRecommend !== option.value) {
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.borderColor = "#e0e0e0";
                      }
                    }}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="wouldRecommend"
                      id={`recommend-${option.value}`}
                      value={option.value}
                      checked={formData.wouldRecommend === option.value}
                      onChange={handleRadioChange}
                    />
                    <label
                      className="form-check-label w-100"
                      htmlFor={`recommend-${option.value}`}
                      style={{ cursor: "pointer", fontWeight: "500" }}
                    >
                      {option.label}
                    </label>
                  </div>
                ))}
              </div>
              {errors.wouldRecommend && (
                <div className="text-danger small">{errors.wouldRecommend}</div>
              )}
            </div>

            {/* Subscription Interest */}
            <div className="mb-4">
              <label className="form-label" style={styles.inputLabel}>
                Would you like to continue with CLIF AI through our subscription
                model after launch?
                <span style={styles.requiredStar}>*</span>
              </label>
              <div className="mb-2 mt-3">
                {[
                  {
                    value: "yes",
                    label: "Yes, I'm interested",
                  },
                  { value: "maybe", label: "Maybe later" },
                  { value: "no", label: "No" },
                ].map((option) => (
                  <div
                    key={option.value}
                    className="form-check mb-3"
                    style={{
                      ...styles.formCheck,
                      backgroundColor:
                        formData.interestedInSubscription === option.value
                          ? "rgba(102, 0, 204, 0.1)"
                          : "transparent",
                      border:
                        formData.interestedInSubscription === option.value
                          ? "1px solid #6600CC"
                          : "1px solid #e0e0e0",
                    }}
                    onMouseOver={(e) => {
                      if (formData.interestedInSubscription !== option.value) {
                        e.currentTarget.style.backgroundColor =
                          "rgba(0, 102, 0, 0.05)";
                        e.currentTarget.style.borderColor = "#006600";
                      }
                    }}
                    onMouseOut={(e) => {
                      if (formData.interestedInSubscription !== option.value) {
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.borderColor = "#e0e0e0";
                      }
                    }}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="interestedInSubscription"
                      id={`subscription-${option.value}`}
                      value={option.value}
                      checked={
                        formData.interestedInSubscription === option.value
                      }
                      onChange={handleRadioChange}
                    />
                    <label
                      className="form-check-label w-100"
                      htmlFor={`subscription-${option.value}`}
                      style={{ cursor: "pointer", fontWeight: "500" }}
                    >
                      {option.label}
                    </label>
                  </div>
                ))}
              </div>
              {errors.interestedInSubscription && (
                <div className="text-danger small">
                  {errors.interestedInSubscription}
                </div>
              )}
            </div>
          </>
        );
      case 4:
        return (
          <>
            <h2 className="mb-4 text-center">Additional Information</h2>

            {/* Email */}
            <div className="mb-4">
              <label
                htmlFor="email"
                className="form-label"
                style={styles.inputLabel}
              >
                Your Email (optional)
              </label>
              <input
                type="email"
                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="your.email@example.com"
                style={{
                  ...styles.formElement,
                  ...styles.inputField,
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#006600";
                  e.target.style.boxShadow =
                    "0 0 0 0.2rem rgba(0, 102, 0, 0.25)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "";
                  e.target.style.boxShadow = "";
                }}
              />
              {errors.email && (
                <div className="invalid-feedback">{errors.email}</div>
              )}
            </div>

            {/* Additional Feedback */}
            <div className="mb-4">
              <label
                htmlFor="additionalFeedback"
                className="form-label"
                style={styles.inputLabel}
              >
                Any other thoughts or feedback you'd like to share?
              </label>
              <textarea
                className="form-control"
                id="additionalFeedback"
                name="additionalFeedback"
                rows="4"
                value={formData.additionalFeedback}
                onChange={handleInputChange}
                placeholder="Share any additional thoughts or feedback here"
                style={{
                  ...styles.formElement,
                  ...styles.inputField,
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#006600";
                  e.target.style.boxShadow =
                    "0 0 0 0.2rem rgba(0, 102, 0, 0.25)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "";
                  e.target.style.boxShadow = "";
                }}
              ></textarea>
            </div>

            {/* Required Fields Note */}
            <div className="mb-4 text-center">
              <small className="text-muted">
                Fields marked with <span style={styles.requiredStar}>*</span>{" "}
                are required
              </small>
            </div>
          </>
        );
      default:
        return null;
    }
  };
  return (
    <>
      <main className="main-wrapper" style={styles.mainBackground}>
        <HeaderFour />
        <div className="section section-padding mt-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div style={styles.mainBackground}>
                  <div className="container mt-5 mb-5">
                    <div className="row justify-content-center">
                      <div className="col-md-10">
                        <div style={styles.cardShadow}>
                          <div style={styles.headerGradient}>
                            <h1 className="h3 mb-2">
                              CLIF AI – MVP Experience Feedback
                            </h1>
                            <p className="text-white-50 mb-0">
                              Help us improve by sharing your experience
                            </p>
                          </div>

                          {/* Progress Steps Indicator */}
                          <div className="p-4 pt-5 pb-0 border-bottom">
                            <div className="row">
                              {[1, 2, 3, 4].map((step) => (
                                <div
                                  key={step}
                                  className="col-3 position-relative"
                                >
                                  <div
                                    style={{
                                      ...styles.stepCircle,
                                      ...(currentStep === step
                                        ? styles.stepCircleActive
                                        : currentStep > step
                                        ? styles.stepCircleCompleted
                                        : styles.stepCirclePending),
                                    }}
                                  >
                                    {currentStep > step ? "✓" : step}
                                  </div>
                                  <div
                                    style={{
                                      ...styles.stepText,
                                      ...(currentStep === step
                                        ? styles.stepTextActive
                                        : currentStep > step
                                        ? styles.stepTextCompleted
                                        : styles.stepTextPending),
                                    }}
                                  >
                                    {step === 1 && "Personal"}
                                    {step === 2 && "Experience"}
                                    {step === 3 && "Feedback"}
                                    {step === 4 && "Details"}
                                  </div>

                                  {step < 4 && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "18px",
                                        right: "-50%",
                                        width: "100%",
                                        height: "2px",
                                        backgroundColor:
                                          currentStep > step
                                            ? "#006600"
                                            : "#E0E0E0",
                                        zIndex: "0",
                                      }}
                                    ></div>
                                  )}
                                </div>
                              ))}
                            </div>

                            <div style={styles.progressBar}>
                              <div
                                style={{
                                  ...styles.progressIndicator,
                                  width: `${(currentStep / totalSteps) * 100}%`,
                                }}
                              ></div>
                            </div>
                          </div>

                          <div className="card-body" style={styles.formSection}>
                            <form onSubmit={handleSubmit}>
                              {renderStepContent(currentStep)}

                              {/* Navigation Buttons */}
                              <div className="d-flex justify-content-between mt-5">
                                {currentStep > 1 ? (
                                  <button
                                    type="button"
                                    onClick={prevStep}
                                    className="btn"
                                    style={{
                                      ...styles.stepButton,
                                      backgroundColor: "#f8f9fa",
                                      color: "#666666",
                                    }}
                                    onMouseOver={(e) => {
                                      e.currentTarget.style.backgroundColor =
                                        "#e9ecef";
                                      e.currentTarget.style.color = "#333333";
                                    }}
                                    onMouseOut={(e) => {
                                      e.currentTarget.style.backgroundColor =
                                        "#f8f9fa";
                                      e.currentTarget.style.color = "#666666";
                                    }}
                                  >
                                    Previous
                                  </button>
                                ) : (
                                  <div></div>
                                )}

                                {currentStep < totalSteps ? (
                                  <button
                                    type="button"
                                    onClick={nextStep}
                                    className="btn"
                                    style={{
                                      ...styles.stepButton,
                                      backgroundColor: "#6600CC",
                                      color: "white",
                                    }}
                                    onMouseOver={(e) => {
                                      e.currentTarget.style.backgroundColor =
                                        "#006600";
                                      e.currentTarget.style.transform =
                                        "translateY(-2px)";
                                      e.currentTarget.style.boxShadow =
                                        "0 4px 8px rgba(0, 102, 0, 0.3)";
                                    }}
                                    onMouseOut={(e) => {
                                      e.currentTarget.style.backgroundColor =
                                        "#6600CC";
                                      e.currentTarget.style.transform =
                                        "translateY(0)";
                                      e.currentTarget.style.boxShadow = "none";
                                    }}
                                  >
                                    Next
                                  </button>
                                ) : (
                                  <button
                                    type="submit"
                                    className="btn"
                                    style={styles.submitButton}
                                    onMouseOver={(e) => {
                                      e.currentTarget.style.backgroundColor =
                                        "#006600";
                                      e.currentTarget.style.transform =
                                        "translateY(-2px)";
                                      e.currentTarget.style.boxShadow =
                                        "0 6px 15px rgba(0, 102, 0, 0.4)";
                                    }}
                                    onMouseOut={(e) => {
                                      e.currentTarget.style.backgroundColor =
                                        "#6600CC";
                                      e.currentTarget.style.transform =
                                        "translateY(0)";
                                      e.currentTarget.style.boxShadow =
                                        "0 4px 12px rgba(102, 0, 204, 0.3)";
                                    }}
                                  >
                                    Submit Feedback
                                  </button>
                                )}
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showPopup && (
            <div className="popup-overlay">
              <ElegantPopup1
                handlePopUpClose={() => handleClose()}
                message="Thank you for your feedback"
              />
            </div>
          )}
        </div>
        <FooterOne />
      </main>
    </>
  );
};

export default FeedbackForm;
